import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGetUserPermissionsQuery } from './SettingsApi';

export default function RequireSuperAdmin({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetUserPermissionsQuery();
  const isSA = data?.user?.isSuperAdmin === true;
  const location = useLocation();

  if (isLoading) {
    return <div></div>;
  }

  if (!isSA) {
    return <Navigate to="/admin/settings" state={{ from: location }} replace />;
  }

  return <div>{children}</div>;
}
